import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import { insideScreenshots } from '../data/sections';
export function InsideCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir === 'left' ? -320 : 320,
      behavior: 'smooth'
    });
  };
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-182" data-mp="2atzxtfk7qign">
      <Container data-id="element-183" data-mp="2om62o5hx130s">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end" data-id="element-184" data-mp="2ompnbtyya5ii">
          <div className="max-w-[650px]" data-id="element-185" data-mp="2km5lwe7cgfqk">
            <SectionTag tone="white" data-id="element-186" data-mp="2yl5cvsibx6pw">Sin letra pequeña</SectionTag>
            <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-[2.75rem]" data-id="element-187" data-mp="2yjar6bz8hakr">
              No te enseñamos solo una portada bonita. Te enseñamos el sistema por dentro.
            </h2>
          </div>

          <div className="hidden gap-2 md:flex" data-id="element-188" data-mp="2rrlpoyhjxeqm">
            <button type="button" onClick={() => scroll('left')} aria-label="Ver capturas anteriores" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-189" data-mp="2ru7tqo58hc43">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-190" data-mp="3aq7p88xf6xsf" />
            </button>
            <button type="button" onClick={() => scroll('right')} aria-label="Ver más capturas" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-191" data-mp="3fhpp0tnpisbt">
              <ChevronRightIcon className="h-5 w-5" data-id="element-192" data-mp="3ti8vvxgfrsce" />
            </button>
          </div>
        </div>

        <div ref={trackRef} className="scrollbar-hide mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2" data-id="element-193" data-mp="1tg10k9y2mzq2">
          {insideScreenshots.map(label => <div key={label} className="w-[78%] flex-shrink-0 snap-start sm:w-[55%] md:w-[calc(33.333%-14px)]" data-id="element-194" data-mp="2362kcpje5vz6">
              <PlaceholderMockup label={label} aspect="aspect-[4/3]" data-id="element-195" data-mp="1ycrf2su89n9d" />
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-[650px] text-center text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-196" data-mp="2d1dusvnroh14">
          Esto es lo que podrás consultar antes de entrar en pista cuando necesites preparar, revisar o adaptar una
          sesión.
        </p>
      </Container>
    </section>;
}